import { render, staticRenderFns } from "./VerifactuHistorical.vue?vue&type=template&id=4ab504e3&scoped=true"
import script from "./VerifactuHistorical.vue?vue&type=script&lang=js"
export * from "./VerifactuHistorical.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab504e3",
  null
  
)

export default component.exports